import React, { useState, useRef, useCallback } from 'react';
import {
  FaFile,
  FaFilePdf,
  FaFileImage,
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileArchive,
  FaFileAudio,
  FaFileVideo,
  FaFileCode,
  FaArrowLeft,
  FaPlus,
} from 'react-icons/fa';
import eyeIcon from '../../assets/Eye.svg';
import { notify } from '../CustomToast';
import { useI18n } from '../../i18n';
import teamRepositoryService from '../../services/teamRepositoryService';
import useTeamRepository from '../../hooks/useTeamRepository';
import ImageViewerModal, { isImageFile } from '../FileManager/ImageViewerModal';
import PdfViewerModal, { isPdfFile } from '../FileManager/PdfViewerModal';
import OnlyOfficeViewerModal from '../FileManager/OnlyOfficeViewerModal';
import folderService from '../../services/folderService';
import DeleteRepoFileModal from './DeleteRepoFileModal';
import './TeamRepository.css';

const DownloadIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.75 10.625V15.625C18.75 15.9565 18.6183 16.2745 18.3839 16.5089C18.1495 16.7433 17.8315 16.875 17.5 16.875H2.5C2.16848 16.875 1.85054 16.7433 1.61612 16.5089C1.3817 16.2745 1.25 15.9565 1.25 15.625V10.625C1.25 10.2935 1.3817 9.97554 1.61612 9.74112C1.85054 9.5067 2.16848 9.375 2.5 9.375H5.625C5.79076 9.375 5.94973 9.44085 6.06694 9.55806C6.18415 9.67527 6.25 9.83424 6.25 10C6.25 10.1658 6.18415 10.3247 6.06694 10.4419C5.94973 10.5592 5.79076 10.625 5.625 10.625H2.5V15.625H17.5V10.625H14.375C14.2092 10.625 14.0503 10.5592 13.9331 10.4419C13.8158 10.3247 13.75 10.1658 13.75 10C13.75 9.83424 13.8158 9.67527 13.9331 9.55806C14.0503 9.44085 14.2092 9.375 14.375 9.375H17.5C17.8315 9.375 18.1495 9.5067 18.3839 9.74112C18.6183 9.97554 18.75 10.2935 18.75 10.625ZM9.55781 10.4422C9.61586 10.5003 9.68479 10.5464 9.76066 10.5779C9.83654 10.6093 9.91787 10.6255 10 10.6255C10.0821 10.6255 10.1635 10.6093 10.2393 10.5779C10.3152 10.5464 10.3841 10.5003 10.4422 10.4422L14.1922 6.69219C14.3095 6.57491 14.3753 6.41585 14.3753 6.25C14.3753 6.08415 14.3095 5.92509 14.1922 5.80781C14.0749 5.69054 13.9159 5.62465 13.75 5.62465C13.5841 5.62465 13.4251 5.69054 13.3078 5.80781L10.625 8.49141V1.875C10.625 1.70924 10.5592 1.55027 10.4419 1.43306C10.3247 1.31585 10.1658 1.25 10 1.25C9.83424 1.25 9.67527 1.31585 9.55806 1.43306C9.44085 1.55027 9.375 1.70924 9.375 1.875V8.49141L6.69219 5.80781C6.57491 5.69054 6.41585 5.62465 6.25 5.62465C6.08415 5.62465 5.92509 5.69054 5.80781 5.80781C5.69054 5.92509 5.62465 6.08415 5.62465 6.25C5.62465 6.41585 5.69054 6.57491 5.80781 6.69219L9.55781 10.4422ZM15.625 13.125C15.625 12.9396 15.57 12.7583 15.467 12.6042C15.364 12.45 15.2176 12.3298 15.0463 12.2589C14.875 12.1879 14.6865 12.1693 14.5046 12.2055C14.3227 12.2417 14.1557 12.331 14.0246 12.4621C13.8935 12.5932 13.8042 12.7602 13.768 12.9421C13.7318 13.124 13.7504 13.3125 13.8214 13.4838C13.8923 13.6551 14.0125 13.8015 14.1667 13.9045C14.3208 14.0075 14.5021 14.0625 14.6875 14.0625C14.9361 14.0625 15.1746 13.9637 15.3504 13.7879C15.5262 13.6121 15.625 13.3736 15.625 13.125Z"
      fill="#414141"
    />
  </svg>
);

const TrashRedIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M60.75 13.5H50.625V10.125C50.625 8.03642 49.7953 6.03338 48.3185 4.55653C46.8416 3.07969 44.8386 2.25 42.75 2.25H29.25C27.1614 2.25 25.1584 3.07969 23.6815 4.55653C22.2047 6.03338 21.375 8.03642 21.375 10.125V13.5H11.25C10.3549 13.5 9.49645 13.8556 8.86351 14.4885C8.23058 15.1214 7.875 15.9799 7.875 16.875C7.875 17.7701 8.23058 18.6286 8.86351 19.2615C9.49645 19.8944 10.3549 20.25 11.25 20.25H12.375V58.5C12.375 59.9918 12.9676 61.4226 14.0225 62.4775C15.0774 63.5324 16.5082 64.125 18 64.125H54C55.4918 64.125 56.9226 63.5324 57.9775 62.4775C59.0324 61.4226 59.625 59.9918 59.625 58.5V20.25H60.75C61.6451 20.25 62.5035 19.8944 63.1365 19.2615C63.7694 18.6286 64.125 17.7701 64.125 16.875C64.125 15.9799 63.7694 15.1214 63.1365 14.4885C62.5035 13.8556 61.6451 13.5 60.75 13.5ZM28.125 10.125C28.125 9.82663 28.2435 9.54048 28.4545 9.3295C28.6655 9.11853 28.9516 9 29.25 9H42.75C43.0484 9 43.3345 9.11853 43.5455 9.3295C43.7565 9.54048 43.875 9.82663 43.875 10.125V13.5H28.125V10.125ZM52.875 57.375H19.125V20.25H52.875V57.375ZM32.625 29.25V47.25C32.625 48.1451 32.2694 49.0035 31.6365 49.6365C31.0036 50.2694 30.1451 50.625 29.25 50.625C28.3549 50.625 27.4964 50.2694 26.8635 49.6365C26.2306 49.0035 25.875 48.1451 25.875 47.25V29.25C25.875 28.3549 26.2306 27.4964 26.8635 26.8635C27.4964 26.2306 28.3549 25.875 29.25 25.875C30.1451 25.875 31.0036 26.2306 31.6365 26.8635C32.2694 27.4964 32.625 28.3549 32.625 29.25ZM46.125 29.25V47.25C46.125 48.1451 45.7694 49.0035 45.1365 49.6365C44.5035 50.2694 43.6451 50.625 42.75 50.625C41.8549 50.625 40.9965 50.2694 40.3635 49.6365C39.7306 49.0035 39.375 48.1451 39.375 47.25V29.25C39.375 28.3549 39.7306 27.4964 40.3635 26.8635C40.9965 26.2306 41.8549 25.875 42.75 25.875C43.6451 25.875 44.5035 26.2306 45.1365 26.8635C45.7694 27.4964 46.125 28.3549 46.125 29.25Z"
      fill="#FF534B"
    />
  </svg>
);

const MAX_FILE_SIZE = 10 * 1024 * 1024;

const OFFICE_EXTENSIONS = [
  'doc',
  'docx',
  'odt',
  'rtf',
  'txt',
  'xls',
  'xlsx',
  'ods',
  'csv',
  'ppt',
  'pptx',
  'odp',
];

const isOfficeFile = (file) => {
  const ext = (file.original_filename || file.name || '')
    .split('.')
    .pop()
    ?.toLowerCase();
  return OFFICE_EXTENSIONS.includes(ext);
};

const getFileIcon = (mimeType, extension) => {
  const ext = (extension || '').toLowerCase();
  if (mimeType?.startsWith('image/'))
    return <FaFileImage className="team-repo-file-icon image" />;
  if (mimeType?.startsWith('video/'))
    return <FaFileVideo className="team-repo-file-icon video" />;
  if (mimeType?.startsWith('audio/'))
    return <FaFileAudio className="team-repo-file-icon audio" />;
  if (mimeType === 'application/pdf')
    return <FaFilePdf className="team-repo-file-icon pdf" />;
  if (mimeType?.includes('word') || ext === 'doc' || ext === 'docx')
    return <FaFileWord className="team-repo-file-icon word" />;
  if (mimeType?.includes('excel') || ext === 'xls' || ext === 'xlsx')
    return <FaFileExcel className="team-repo-file-icon excel" />;
  if (mimeType?.includes('powerpoint') || ext === 'ppt' || ext === 'pptx')
    return <FaFilePowerpoint className="team-repo-file-icon" />;
  if (
    mimeType?.includes('zip') ||
    mimeType?.includes('rar') ||
    mimeType?.includes('7z')
  )
    return <FaFileArchive className="team-repo-file-icon" />;
  if (
    mimeType?.includes('javascript') ||
    mimeType?.includes('json') ||
    mimeType?.includes('html') ||
    mimeType?.includes('css')
  )
    return <FaFileCode className="team-repo-file-icon code" />;
  return <FaFile className="team-repo-file-icon" />;
};

const formatDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  const day = String(d.getDate()).padStart(2, '0');
  const month = d.toLocaleString('en', { month: 'short' });
  const year = d.getFullYear();
  const time = d.toLocaleString('en', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
  return `${day}-${month}-${year} ${time}`;
};

const TeamRepository = ({ team, currentUserId, onBack }) => {
  const { t } = useI18n();
  const {
    files,
    loading,
    loadingMore,
    hasMore,
    loadMore,
    prependFile,
    removeFile,
  } = useTeamRepository(team.id);
  const [uploadProgress, setUploadProgress] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const fileInputRef = useRef(null);

  // Viewer state
  const [imageViewerFile, setImageViewerFile] = useState(null);
  const [pdfViewerFile, setPdfViewerFile] = useState(null);
  const [officeViewerFile, setOfficeViewerFile] = useState(null);

  const observer = useRef();
  const lastFileRef = useCallback(
    (node) => {
      if (loading || loadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) loadMore();
      });
      if (node) observer.current.observe(node);
    },
    [loading, loadingMore, hasMore, loadMore]
  );

  const handleDownload = async (e, file) => {
    e.stopPropagation();
    try {
      const blob = await teamRepositoryService.downloadFile(team.id, file.id);
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = file.original_filename || file.name || 'file';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    } catch {
      notify('error', t('pages.teams.repository_download_failed'));
    }
  };

  const handleFileClick = async (file) => {
    if (isImageFile(file)) {
      const imageFiles = files.filter(isImageFile);
      setImageViewerFile({ file, allImages: imageFiles });
      return;
    }
    if (isPdfFile(file)) {
      setPdfViewerFile(file);
      return;
    }
    if (isOfficeFile(file)) {
      setOfficeViewerFile(file);
      return;
    }
    // All other file types — open in new tab
    try {
      const res = await folderService.getFileViewUrl(file.id);
      if (res?.status && res?.data?.url) {
        window.open(res.data.url, '_blank', 'noopener,noreferrer');
      }
    } catch {
      notify('error', t('pages.teams.repository_download_failed'));
    }
  };

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > MAX_FILE_SIZE) {
      notify('error', t('pages.teams.repository_file_too_large'));
      if (fileInputRef.current) fileInputRef.current.value = '';
      return;
    }

    setUploadProgress(0);

    try {
      const res = await teamRepositoryService.uploadFile(
        team.id,
        file,
        (event) => {
          if (event.total) {
            setUploadProgress(Math.round((event.loaded / event.total) * 100));
          }
        }
      );
      prependFile(res?.data?.file);
      notify('success', t('pages.teams.repository_upload_success'));
    } catch {
      notify('error', t('pages.teams.repository_upload_failed'));
    } finally {
      setUploadProgress(null);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  const handleDeleteConfirm = async () => {
    if (!deleteTarget) return;
    setDeletingId(deleteTarget.id);
    try {
      await teamRepositoryService.deleteFile(team.id, deleteTarget.id);
      removeFile(deleteTarget.id);
      notify('success', t('pages.teams.repository_delete_success'));
      setDeleteTarget(null);
    } catch {
      notify('error', t('pages.teams.repository_delete_failed'));
    } finally {
      setDeletingId(null);
    }
  };

  const canDelete = () => team.owner_id === currentUserId;

  const allImageFiles = files.filter(isImageFile);

  return (
    <div className="teams teams-section-container news-feed-section-container">
      <div className="team-repo-header">
        <button className="team-repo-back-btn" onClick={onBack}>
          <FaArrowLeft size={13} />
          {t('pages.teams.repository_back')}
        </button>
        <h1 className="team-repo-title">
          {team.name} — {t('pages.teams.repository_title')}
        </h1>
      </div>

      {uploadProgress !== null && (
        <div className="team-repo-progress">
          <div
            className="team-repo-progress-bar"
            style={{ width: `${uploadProgress}%` }}
          />
        </div>
      )}

      <input
        ref={fileInputRef}
        type="file"
        style={{ display: 'none' }}
        onChange={handleUpload}
      />

      {loading ? (
        <div className="team-repo-grid">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="team-repo-file team-repo-skeleton-card">
              <div className="team-repo-sk team-repo-sk-name" />
              <div className="team-repo-sk team-repo-sk-icon" />
              <div className="team-repo-file-meta" style={{}}>
                <div className="team-repo-sk team-repo-sk-avatar" />
                <div className="team-repo-meta-text">
                  <div className="team-repo-sk team-repo-sk-line" />
                  <div className="team-repo-sk team-repo-sk-line-sm" />
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="team-repo-grid">
          {/* Upload card */}
          <div
            className="team-repo-upload-card"
            onClick={() =>
              uploadProgress === null && fileInputRef.current?.click()
            }
            role="button"
            aria-label={t('pages.teams.repository_upload_btn')}
          >
            <div className="team-repo-upload-icon">
              {uploadProgress !== null ? `${uploadProgress}%` : <FaPlus />}
            </div>
            <div className="team-repo-upload-label">
              {t('pages.teams.repository_add_document')}
            </div>
          </div>

          {files.map((file, index) => {
            const isLast = index === files.length - 1;
            return (
              <div
                key={file.id}
                ref={isLast ? lastFileRef : null}
                className="team-repo-file"
                onClick={() => handleFileClick(file)}
                style={{ cursor: 'pointer' }}
              >
                <div className="team-repo-file-name">
                  {file.original_filename}
                </div>
                {getFileIcon(file.mime_type, file.extension)}
                <div className="team-repo-file-info" />

                <div className="team-repo-file-meta">
                  {file.owner?.avatar_url ? (
                    <img
                      src={file.owner.avatar_url}
                      alt=""
                      className="team-repo-avatar"
                    />
                  ) : (
                    <div className="team-repo-avatar team-repo-avatar-initials">
                      {(file.owner?.name || '?')[0].toUpperCase()}
                    </div>
                  )}
                  <div className="team-repo-meta-text">
                    <span className="team-repo-meta-name">
                      {file.owner?.name ||
                        t('pages.teams.repository_unknown_uploader')}
                    </span>
                    <span className="team-repo-meta-date">
                      {formatDate(file.created_at)}
                    </span>
                  </div>
                </div>

                <div className="team-repo-file-actions">
                  <button
                    className="team-repo-action-btn"
                    title={t('common.actions.view')}
                    onClick={(e) => { e.stopPropagation(); handleFileClick(file); }}
                  >
                    <img src={eyeIcon} alt="View" width={22} height={22} />
                  </button>
                  <button
                    className="team-repo-action-btn"
                    title={t('pages.teams.repository_download')}
                    onClick={(e) => handleDownload(e, file)}
                  >
                    <DownloadIcon />
                  </button>
                  {canDelete() && (
                    <button
                      className="team-repo-action-btn delete"
                      title={t('pages.teams.repository_delete')}
                      onClick={(e) => {
                        e.stopPropagation();
                        setDeleteTarget(file);
                      }}
                      disabled={deletingId === file.id}
                    >
                      <TrashRedIcon />
                    </button>
                  )}
                </div>
              </div>
            );
          })}

          {/* Pagination skeleton cards — inside grid to fill remaining row spaces */}
          {loadingMore &&
            Array.from({ length: 3 }).map((_, i) => (
              <div
                key={`skeleton-more-${i}`}
                className="team-repo-file team-repo-skeleton-card"
              >
                <div className="team-repo-sk team-repo-sk-name" />
                <div className="team-repo-sk team-repo-sk-icon" />
                <div className="team-repo-file-meta" style={{}}>
                  <div className="team-repo-sk team-repo-sk-avatar" />
                  <div className="team-repo-meta-text">
                    <div className="team-repo-sk team-repo-sk-line" />
                    <div className="team-repo-sk team-repo-sk-line-sm" />
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}

      {/* Delete confirmation modal */}
      <DeleteRepoFileModal
        isOpen={!!deleteTarget}
        onClose={() => setDeleteTarget(null)}
        onConfirm={handleDeleteConfirm}
        file={deleteTarget}
        loading={deletingId === deleteTarget?.id}
      />

      {/* Image viewer */}
      {imageViewerFile && (
        <ImageViewerModal
          file={imageViewerFile.file}
          allImages={imageViewerFile.allImages}
          onClose={() => setImageViewerFile(null)}
        />
      )}

      {/* PDF viewer */}
      {pdfViewerFile && (
        <PdfViewerModal
          file={pdfViewerFile}
          onClose={() => setPdfViewerFile(null)}
        />
      )}

      {/* OnlyOffice viewer */}
      {officeViewerFile && (
        <OnlyOfficeViewerModal
          file={officeViewerFile}
          onClose={() => setOfficeViewerFile(null)}
        />
      )}
    </div>
  );
};

export default TeamRepository;
